/**
 * MainBackgroundContainer component.
 */
import styled from 'styled-components';

/**
 * Styled main background container.
 */
const MainBackgroundContainer = styled.div`
  background: #1f1f1f;
  position: absolute;
  height: 100vh;
  width: 100vw;
`;

export default MainBackgroundContainer;
